import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./category.scss";
import arrow_icon from "../../assets/arrow_sign.svg";

export const categoryItems = [
  {
    id: 12,
    title: "Tzadikim",
    showTitle: "צדיקים",
    src: require("../../assets/catergory_image1A.png"),
    icon: require("../../assets/catergory_image2B.png"),
  },
  {
    id: 1,
    title: "Cemeteries",
    showTitle: "בית החיים",
    src: require("../../assets/catergory_image2A.png"),
    icon: require("../../assets/catergory_image2B.png"),
  },
  {
    id: 7,
    title: "Mikvah",
    showTitle: "מקוה",
    src: require("../../assets/catergory_image3A.png"),
    icon: require("../../assets/catergory_image3B.png"),
  },
  {
    id: 2,
    title: "Synagogues",
    showTitle: "בית המדרש",
    src: require("../../assets/catergory_image4A.png"),
    icon: require("../../assets/catergory_image4B.png"),
  },
  {
    id: 5,
    title: "Food",
    showTitle: "מזון",
    src: require("../../assets/catergory_image5A.png"),
    icon: require("../../assets/catergory_image5B.png"),
  },
  {
    id: 4,
    title: "Hotels",
    showTitle: "אכסניא",
    src: require("../../assets/catergory_image6A.png"),
    icon: require("../../assets/catergory_image6B.png"),
  },
  {
    id: 10,
    title: "Airports",
    showTitle: "עירפארט",
    src: require("../../assets/catergory_image7A.png"),
    icon: require("../../assets/catergory_image7B.png"),
  },
  {
    id: 9,
    title: "Historical Places",
    showTitle: "היסטאריע",
    src: require("../../assets/catergory_image8A.png"),
    icon: require("../../assets/catergory_image8B.png"),
  },
];

function Category() {
  const navigate = useNavigate();
  const [isHover, setIsHover] = useState("");

  return (
    <div className="nt-categories-container">
      {categoryItems.map((category, index) => (
        <div
          onClick={() =>
            navigate("/category-list", {
              state: {
                id: category.id,
                title: category.title,
                subTitle: category.showTitle,
                categoryName: category?.title,
                categoryTitle: category?.showTitle,
                categoryIcon: category.icon,
              },
            })
          }
          className="nt-category-item"
          key={category.id}
          state={{
            categoryName: category.title,
            categoryTitle: category.showTitle,
            categoryIcon: category.icon,
          }}
          onMouseOver={() =>
            setIsHover({
              hoverKeyName: index,
              hoverValue: (
                <img src={arrow_icon} className="nt-arrow_icon" alt=""></img>
              ),
            })
          }
          onMouseOut={() => setIsHover("")}
        >
          <img
            className="nt-category-image"
            src={category.src}
            alt={category.title}
          />
          <p className="nt-category-title">
            {category.showTitle}{" "}
            {isHover?.hoverKeyName === index ? isHover?.hoverValue : null}
          </p>
        </div>
      ))}
    </div>
  );
}

export default Category;
